import { StyledTableCell } from '../../table/StyledTableCell';
import { OwnerSelect } from '../OwnerSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export function MilestoneOwnerContent({
  milestone,
  ownerCandidates,
  onOwnerChange,
  ownerCandidatesLoading,
  renderAvatar,
  sellerGroupName,
  showName
}) {
  return /*#__PURE__*/_jsx(OwnerSelect, {
    candidates: ownerCandidates,
    currentOwner: milestone.owner,
    onOwnerChange: owner => onOwnerChange(milestone, owner),
    renderAvatar: renderAvatar,
    loading: ownerCandidatesLoading,
    showName: showName,
    sellerGroupName: sellerGroupName
  });
}
export function MilestoneOwnerCell(props) {
  return /*#__PURE__*/_jsx(StyledTableCell, {
    children: /*#__PURE__*/_jsx(MilestoneOwnerContent, Object.assign({}, props))
  });
}